import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WhitelevelComponent } from './whitelevel/whitelevel.component';

const routes: Routes = [
  { path:'', component: WhitelevelComponent}, 
  { path: 'x', component: WhitelevelComponent },
  {path:'user', canActivate:[],data:{preload:true, role:'u'}, loadChildren:()=> import('./user/user.module').then(m=>m.UserModule)},
  {path:'', canActivate:[],data:{preload:true, role:'a'}, loadChildren:()=> import('./customer/admin.module').then(m=>m.AdminModule)},
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
